import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';

export default function ThankYou() {
  // NOTE: /thank_you is Croatian-only per spec.
  const { i18n, t } = useTranslation();
  // Force Croatian strings regardless of currently selected language:
  const hr = i18n.getFixedT('hr');
  return (
    <main className="pt-[72px] min-h-[80vh] flex items-center">
      <div className="max-w-[720px] mx-auto px-5 md:px-10 py-20 md:py-28 text-center">
        <div className="inline-flex items-center gap-2 bg-white border border-[#0B1E3F]/10 rounded-full px-4 py-1.5 text-[11.5px] uppercase tracking-[0.16em] text-[#0B1E3F]/70">
          <span className="w-1.5 h-1.5 rounded-full bg-[#E9B949]" />
          {hr('thankyou.eyebrow')}
        </div>
        <h1 className="mt-6 font-serif text-[40px] md:text-[62px] leading-[1.05] font-semibold tracking-[-0.02em] text-[#0B1E3F]">
          {hr('thankyou.title')}
        </h1>
        <p className="mt-6 text-[16px] md:text-[17px] leading-relaxed text-[#0B1E3F]/70">
          {hr('thankyou.body')}
        </p>
        <Link
          to="/"
          className="mt-10 inline-flex items-center gap-2 bg-[#0B1E3F] hover:bg-[#12295a] text-white text-[14px] font-semibold px-6 py-3.5 rounded-full transition"
          data-testid="thankyou-back"
        >
          {hr('thankyou.backHome')} <ArrowRight size={16} />
        </Link>
      </div>
    </main>
  );
}
